import catchify from 'catchify';

export default (context, inject) => {
  const convert = async (metrics) => {
    const { $cookies } = context;

    const [err, response] = await catchify(context.$axios({
      method: 'post',
      url: '/api/sumotest/convert/',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRFToken': $cookies.get('csrftoken'),
      },
      data: {
        metrics,
      },
    }));

    if (err) {
      // eslint-disable-next-line no-console
      console.log('Error Experiment Convert:', err);
      return;
    }

    const { data } = response;

    if (data && !data.success) {
      // eslint-disable-next-line no-console
      console.log('Error Experiment Convert: ', data.error);
    }
  };

  // NOTE: if using `true` or `false` variant slugs, server returns as string,
  //  but cookie saves as a boolean
  const enroll = async (name, checkCookie = true) => {
    const { $cookies, $axios } = context;

    const override = context.query[`sumotest-${name}`];
    const reset = String(context.query[`sumotest-reset-${name}`]) === '1';

    if (override) {
      return override;
    }

    if (reset) {
      $cookies.remove(`__experiment_${name}`);
    } else if (checkCookie) {
      const existExp = $cookies.get(`__experiment_${name}`);

      if (existExp) {
        return existExp;
      }
    }

    let query = `experiment=${encodeURIComponent(name)}`;
    if (reset) {
      query += `&sumotest-reset-${name}=1`;
    }

    const [err, response] = await catchify($axios({
      method: 'GET',
      url: `/api/sumotest/enroll/?${query}`,
      withCredentials: true,
    }));

    if (err) {
      console.log('Error Enrolling in Experiment:', err); // eslint-disable-line no-console
      return null;
    }

    const variant = (response && response.data && response.data.variant) || '';

    if (variant) {
      $cookies.set(`__experiment_${name}`, variant, {
        path: '/',
        maxAge: 60, // Expire after 1 min
      });
    }

    return variant;
  };

  const experiments = {
    convert,
    enroll,
  };

  inject('experiments', experiments);
  context.$experiments = experiments;
};
